import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import MainframeSolutions from "../pages/mainframe-solutions/page";
import BuildFitAI from "../pages/buildfit-ai/page";
import Speaking from "../pages/speaking/page";
import PressMedia from "../pages/press-media/page";
import BoardAdvisory from "../pages/board-advisory/page";
import Contact from "../pages/contact/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsOfUse from "../pages/terms-of-use/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/board-advisory",
    element: <BoardAdvisory />,
  },
  {
    path: "/mainframe-solutions",
    element: <MainframeSolutions />,
  },
  {
    path: "/buildfit-ai",
    element: <BuildFitAI />,
  },
  {
    path: "/speaking",
    element: <Speaking />,
  },
  {
    path: "/press-media",
    element: <PressMedia />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-of-use",
    element: <TermsOfUse />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;